export const links = {
  tnc_link:
    "https://assets.ctfassets.net/50eu6hwcly4u/01pnZz8qVNk1vb46t7FbtJ/0304345816e9f472778607b6147b95b6/citizenM_booking_terms_conditions_EN.pdf",
  tnc_us_link:
    "https://www.citizenm.com/terms-and-conditions-mycitizenmplus-us",
  tnc_plus_link:
    "https://assets.ctfassets.net/50eu6hwcly4u/3GsuEhvLUIFXZYkR7maLZh/92164e2d656cd2a679d5983efd20a33f/20240404_mycitizenM__T_Cs__1_.pdf",
  privacy_link:
    "https://assets.ctfassets.net/50eu6hwcly4u/1Nxxlp3l5nzJXPuKwjUI7R/f5cac7f5872d994de69e7307b3302b3b/20240712_EN_citizenM_guest_privacy_statement.pdf",
};

export default links;
